import "./_page-6.scss";
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page6() {
    const name = "page6";

    const {data, setData} = useVMStore();

    const values = ["Ihre eigene Standardvorlage", "VMTS's Vorlage"];

    return (
        <Form className="d-flex flex-column flex-md-row">
            <span className="exclamation">
                <img className="icon" src={process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/exclamation.svg"} alt="" />
                <span className="warning-text">Erhöhen die zusätzlichen Kosten ca. 2% des Gesamtpreises.</span>
            </span>
            {values.map((v, idx) => (
                <Form.Check
                    type="radio"
                    key={"page_6_op_" + idx}
                    id={"page_6_op_" + idx}
                    className="mb-3 col"
                    label={v}
                    value={v}
                    checked={data[name] === v}
                    onChange={(e) => {
                        setData(e.target.value, "page6");
                    }}
                />
            ))}
        </Form>
    );
}
